import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { jwtInterceptor } from './core/interceptors/jwt.interceptor';
import { uploadInterceptor } from './core/interceptors/upload.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';

import {
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
} from '@azure/msal-angular';
import {
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
} from '@azure/msal-browser';

import { NotificationService } from '@progress/kendo-angular-notification';
import { ICON_SETTINGS } from '@progress/kendo-angular-icons';
import { setScriptKey } from '@progress/kendo-licensing';
import { environment } from '../environments/environment';

setScriptKey(environment.KENDO_UI_LICENSE);

function MSALInstanceFactory(): PublicClientApplication {
  const app = new PublicClientApplication({
    auth: {
      clientId: '22d65eba-90a8-4bfe-9d6c-2e5942ee98c3',
      redirectUri:
        typeof window !== 'undefined'
          ? window.location.origin + '/auth/login'
          : '/auth/login',
      postLogoutRedirectUri:
        typeof window !== 'undefined'
          ? window.location.origin + '/auth/login'
          : '/auth/login',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
  });
  return app;
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: false }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([loadingInterceptor, jwtInterceptor, uploadInterceptor])),
    provideAnimations(),

    // Kendo UI
    NotificationService,
    { provide: ICON_SETTINGS, useValue: { type: 'font' } },

    // MSAL
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useValue: {
        interactionType: InteractionType.Redirect,
        authRequest: { scopes: ['user.read'] },
        loginFailedRoute: '/login-failed',
      },
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useValue: {
        interactionType: InteractionType.Popup,
        protectedResourceMap: new Map([
          ['https://graph.microsoft-ppe.com/v1.0/me', ['user.read']],
        ]),
      },
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
};
